<script>
import Vue from 'vue'
let localGameType = [
  {
    code: 'lottery',
    name: '彩票游戏',
    abbrName: '彩票',
    isShowProxyRp: 1,
    isEnable: 1
  },
  {
    code: 'realman',
    name: '真人视讯',
    abbrName: '真人',
    isShowProxyRp: 1,
    isEnable: 1
  },
  {
    code: 'chess',
    name: '棋牌游戏',
    abbrName: '棋牌',
    isShowProxyRp: 1,
    isEnable: 1
  },
  {
    code: 'elegame',
    name: '电子游艺',
    abbrName: '电子',
    isShowProxyRp: 1,
    isEnable: 1
  },
  {
    code: 'sports',
    name: '体育电竞',
    abbrName: '体育电竞',
    isShowProxyRp: 1,
    isEnable: 1
  }
]
export default {
  computed: {
    gameType() {
      let appConfig = this.$store.state.app.appConfig
      let configGameType = []
      try {
        configGameType = appConfig.app_config.configValue.app_game_access.value
        configGameType = configGameType instanceof Array ? configGameType : localGameType
      } catch {
        console.warn('未找到游戏类型配置 请检查配置表 app_config > app_game_access')
        configGameType = localGameType
      }

      //排序并合并对象
      let gameType = []
      configGameType.forEach(item => {
        let type = localGameType.find(e => {
          return item.code == e.code
        })
        type &&
          gameType.push({
            ...type,
            ...item
          })
      })

      return gameType
    },
    originPlatformList() {
      return this.$store.state.thirdparty.platformList
    },
    dsfRealmanPlatformList() {
      return this.originPlatformList
        .filter(platform => platform.isSupportRealman === 1)
        .sort((a, b) => {
          return a.realmanOrderNum - b.realmanOrderNum
        })
    },
    dsfEGamePlatformList() {
      return this.originPlatformList
        .filter(platform => platform.isSupportElegame === 1)
        .sort((a, b) => {
          return a.elegameOrderNum - b.elegameOrderNum
        })
    },
    dsfChessPlatformList() {
      return this.originPlatformList
        .filter(platform => platform.isSupportChess === 1)
        .sort((a, b) => {
          return a.chessOrderNum - b.chessOrderNum
        })
    },
    dsfSportsPlatformList() {
      return this.originPlatformList
        .filter(platform => platform.isSupportSports === 1)
        .sort((a, b) => {
          return a.sportsOrderNum - b.sportsOrderNum
        })
    },
    dsfDianjingPlatformList() {
      return this.originPlatformList
        .filter(platform => platform.isSupportElesports === 1)
        .sort((a, b) => {
          return a.elesportsOrderNum - b.elesportsOrderNum
        })
    },
    dsfFishPlatformList() {
      return this.originPlatformList
        .filter(platform => platform.isSupportFish === 1)
        .sort((a, b) => {
          return a.fishOrderNum - b.fishOrderNum
        })
    },
    // 用于投注记录
    dsfWithoutDev() {
      let realman = this.dsfRealmanPlatformList
      let elegameArr = this.dsfEGamePlatformList
      let chess = this.dsfChessPlatformList
      let sportsArr = this.dsfSportsPlatformList
      let electricArr = this.dsfDianjingPlatformList
      let fishArr = this.dsfFishPlatformList
      let arrNewEle = new Set([...elegameArr, ...fishArr])
      let arrNew = new Set([...sportsArr, ...electricArr])
      let elegame = Array.from(arrNewEle)
      let sports = Array.from(arrNew)
      return { realman, elegame, chess, sports }
    },
    // 用于转账
    platformList() {
      // let dsfWithoutDev = this.dsfWithoutDev
      // let gameType = this.gameType
      // let dsf = []
      // for (let key in dsfWithoutDev) {
      //   if (gameType.find(e => e.code == key)) {
      //     let arr = new Set([...dsf, ...dsfWithoutDev[key]])
      //     dsf = Array.from(arr)
      //   }
      // }

      //排序
      const sort = this.originPlatformList.filter(item => item.isShowTransfer === 1)
      // let platformList = sort.filter(item =>
      //   dsf.find(e => e.platformCode == item.platformCode)
      // )
      return sort
    }
  }
}
</script>
